import React from 'react';

import cl from './PrivateBanking.module.css'

import woomenImg from '../../../assets/images/woomenImg.png'
import processImg from '../../../assets/images/process.png'
import manWorkImg from '../../../assets/images/man_work.png'

import spendingsImg from '../../../assets/images/Spendings.png'
import profitImg from '../../../assets/images/profit.png'

import plane from '../../../assets/images/plane.svg'
import handsImg from '../../../assets/images/hands.svg'

import corePrivateImg1 from '../../../assets/images/core_private_img1.svg'
import corePrivateImg2 from '../../../assets/images/core_private_img2.svg'
import corePrivateImg3 from '../../../assets/images/core_private_img3.svg'
import corePrivateImg4 from '../../../assets/images/core_private_img4.svg'
import corePrivateImg5 from '../../../assets/images/core_private_img5.svg'
import corePrivateImg6 from '../../../assets/images/core_private_img6.svg'
import corePrivateImg7 from '../../../assets/images/core_private_img7.svg'

import blackImgPenNote from '../../../assets/images/blackpenImg.png'
import whiteCircleImg from '../../../assets/images/whiteCircle.png'


import multi_currency_item1 from '../../../assets/images/multi_currency_item1.svg'
import multi_currency_item2 from '../../../assets/images/multi_currency_item2.svg'
import multi_currency_item3 from '../../../assets/images/multi_currency_item3.svg'
import multi_currency_item4 from '../../../assets/images/multi_currency_item4.svg'
import { NavLink } from 'react-router-dom';







const PrivateBanking = () => {
    return (
        <>
        <div className={cl.private_banking_container}>
           <h2 className={cl.private_banking_title}>
                Fortres BanCorp
           </h2>
           <div className={cl.private_banking_descr_wrapper}>
                <p className={cl.private_banking_descr}>
                    International Private Bankers, nearly 24/7—worldwide and digital.
                </p>
           </div>
        <div className={cl.private_banking_items_row}>
            <div className={cl.private_left}>
                <div className={cl.left_img_wrapper}>
                    <img src={woomenImg} alt="" />
                </div>
                <div className={cl.block_item4}>
                    <div className={cl.img_wrapper}>
                        <img src={handsImg} alt="" />
                    </div>
                    <h3 className={cl.block_item_title}>
                        Bespoke Private Banking
                    </h3>
                    <p className={cl.block_descr_white}>
                        Your Fortres BanCorp Private Banker designs fully tailored solutions—even for complex requests.
                    </p>
                </div>
            </div>
            <div className={cl.private_center}>
                 <div className={cl.block_item2}>
                    <div className={cl.img_wrapper}>
                        <img src={plane} alt="" />
                    </div>
                    <h3 className={cl.block_item2_title}>
                        International Presence, No Borders
                    </h3>
                    <p className={cl.block_descr_black}>
                        Flexible, discreet, and more secure accounts for globally minded clients.
                    </p>

                </div>
                <div className={cl.block_item5}>
                    <img src={processImg} alt="" />
                </div> 
            </div>
            <div className={cl.private_right}>
                 <img src={manWorkImg} alt="" />
            </div>
           
        </div>
        <div className={cl.build_expertise_container}>
            <div className={cl.left_build_expertise}>
                <h2 className={cl.left_build_title}>
                    Built on Expertise. Focused on Results
                </h2>
                <div className={cl.left_build_descr_wrapper}>
                    <p className={cl.left_build_descr}>
                        With a solid foundation in financial management, we help clients <span className={cl.important_text_protect}>protect and grow</span> wealth through strategies aimed at above-average returnsand selective, highly secure lending.
                    </p>
                </div>
                <NavLink to='/sign-up' className={cl.link_sign_up}>
                    <div className={cl.build_btn}>
                        Open Account
                    </div>
                </NavLink>
            </div>
            <div className={cl.right_build_expertise}>
                <div className={cl.img_spendings_wrapper}>
                    <img src={spendingsImg} alt="" />
                </div>
                <div className={cl.img_profit_wrapper}>
                    <img src={profitImg} alt="" />
                </div>
            </div>
        </div>
        <div className={cl.core_private_container}>
            <h2 className={cl.core_private_title}>
                Core Private Banking Services
            </h2>
            <p className={cl.core_private_descr}>
                Delivered through a secure digital channel, our services include:
            </p>
            <div className={cl.upper_container}>
                <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg1} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Multi-currency deposit accounts
                    </h4>
                </div>

            </div>
            <div className={cl.mid_container}>
                <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg2} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Custody of digital assets and execution services
                    </h4>
                </div>
                <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg3} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Trading and brokerage
                    </h4>
                </div>
                <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg4} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Bespoke investment solutions
                    </h4>
                </div>
                 <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg5} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Foreign Exchange: spot, forward, swap, and lending
                    </h4>
                </div>
                 <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg6} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        OTC and derivatives instruments
                    </h4>
                </div>
                 <div className={cl.item_core}>
                    <div className={cl.img_item_wrapper}>
                        <img src={corePrivateImg7} alt="" />
                    </div>
                    <h4 className={cl.core_item_title}>
                        Payments, transfers, and credit cards
                    </h4>
                </div>
            </div>
            
        </div>
        <div className={cl.multi_currency_container}>
            <div className="left_multi_currency_items">
                <div className={cl.multi_currency_item}>
                    <div className="multi_currency_img_wrapper">
                        <img src={multi_currency_item1} alt="" />
                    </div>
                    <span className={cl.multi_currency_item_title}>Consolidate and manage foreign receivables and payments efficiently</span>
                </div>
                 <div className={cl.multi_currency_item}>
                    <div className="multi_currency_img_wrapper">
                        <img src={multi_currency_item2} alt="" />
                    </div>
                    <span className={cl.multi_currency_item_title}>Send and receive wire payments and settle credit card bills without   currency conversion</span>
                </div>
                 <div className={cl.multi_currency_item}>
                    <div className="multi_currency_img_wrapper">
                        <img src={multi_currency_item3} alt="" />
                    </div>
                    <span className={cl.multi_currency_item_title}>Conduct transactions in most major world currencies</span>
                </div>
                 <div className={cl.multi_currency_item}>
                    <div className="multi_currency_img_wrapper">
                        <img src={multi_currency_item4} alt="" />
                    </div>
                    <span className={cl.multi_currency_item_title}>View balances and activities for all currency accounts online</span>
                </div>
            </div>
            <div className="right_multi_currency">
                <h2 className={cl.multi_currency_title}>
                    Multi-Currency Account (MCA)
                </h2>
                <div className="multi_currecny_descr_wrapper">
                    <p className={cl.multi_currency_descr}>
                        The MCA is the hub of your Private Banking relationship, offering international   clients ultimate convenience:
                    </p>
                </div>
            </div>
        </div>
        </div>
        <div className={cl.open_your_account_background}>
            <div className={cl.open_your_accont_content}>
                <div className={cl.left_open_acount}>
                    <h2 className={cl.open_account_title}>
                        Open Your Account Online
                    </h2>
                    <div className={cl.open_account_descr_wrapper}>
                        <p className={cl.open_account_descr}>
                            Or schedule a call with our International Private Banking team today.
                        </p>
                    </div>
                    <>
                    <NavLink to='/sign-up' className={cl.link_sign_up}>
                        <div className={cl.open_account_btn_white}>
                            Open Account
                        </div>
                    </NavLink>
                    </>
                </div>
                <div className={cl.right_open_account}>
                    
                        <img src={blackImgPenNote} alt="" className={cl.img_mens_wrapper} />
                    
                    
                        <img src={whiteCircleImg} alt="" className={cl.img_circle_wrapper} />
                    
                </div>
            </div>
        </div>
        </>
    );
};

export default PrivateBanking;